"use client";
import React from "react";
import TeamOverviewFilter from "./filter";
import { Sport, TeamOverview } from "common";
import { formatRankSuffix } from "@/utils";

export default function TeamLayoutHeader(
    {data, params}: {data: TeamOverview, params: {sport: Sport, year: string, team: string}}
) {
  const [animate, setAnimate] = React.useState<boolean>(false);
  React.useEffect(() => {
    setAnimate(true);
  }, []);
  if (!data) return;
    console.log("team overview:", data);
    const teamScores = [
      {
        name: "ATS record",
        total: `${data.againstSpread.wins}-${data.againstSpread.losses}-${data.againstSpread.ties}`,
      },
      {
        name: "Total (O/U)",
        total: `${data.overUnders.wins}-${data.overUnders.losses}-${data.overUnders.ties}`,
      },
      {
        name: "Last 10",
        total: `${data.last10Record.wins}-${data.last10Record.losses}-${params.sport === "nhl" ? data.last10Record.overtimeLosses : data.last10Record.ties}`,
      },
    ];
  return (
    <div
        className="team-header relative h-[295px] md:h-72"
        style={{ backgroundColor: `#${data.primaryColor}`}}
      >
        <div className="h-full container pt-8 pb-8 md:pt-16 md:pb-16 relative">
          <div className="team-header-logo_left top-2/4">
            <img
              src={data.logoUrl}
              role="presentation"
              className="absolute w-full h-auto max-w-none pointer-events-none"
            />
          </div>
          <div className="team-header-logo_right w-[96px] h-[96px] md:w-[367px] md:h-[367px] right-4 md:-right-[46px] top-[26%] md:top-[53%]" style={{transform: animate ? "translateY(-50%) scale(1.0)" : "translateY(-50%) scale(1.333)"}}>
            <img
              src={data.logoUrl}
              role="presentation"
              className="w-full h-auto object-fill max-w-none pointer-events-none"
            />
          </div>
          <div className="flex flex-col md:flex-row items-start md:items-center gap-x-4 gap-y-3 mb-5">
            <h1 className="block md:hidden text-display-lg leading-none uppercase text-white">
              <span>{data.location}</span>
              <br></br>
              <span>{data.name}</span>
            </h1>
            <h1 className="hidden md:block text-display-xl leading-none uppercase text-white">
              {data.location} {data.name}
            </h1>
            <TeamOverviewFilter params={params} />
          </div>
          <div className="flex gap-2 items-center mb-5 relative z-[1] mt-8">
            <p className="text-headline-medium uppercase text-white">{data.wins} - {data.losses} {params.sport === "nhl" ? `- ${data.overtimeLosses}` : ""}</p>
            <div className="bg-white w-px h-4 opacity-20"></div>
            <p className="text-body text-white">{data.rank}{formatRankSuffix(data.rank)} in <span className="uppercase">{data.sport}</span></p>
            <div className="bg-white w-px h-4 opacity-20"></div>

            <p className="text-body text-white">{data.divisionRank}{formatRankSuffix(data.divisionRank)} in {data.division}</p>
          </div>
          <div className="team-header-scores flex gap-4 relative z-[1]">
            {teamScores.map((score, i) => {
              return (
                <div
                  key={i}
                  className="team-header-scores_item flex flex-row gap-4 uppercase"
                >
                  <div className="flex flex-col gap-2 uppercase">
                    <span className="text-label-sm text-white">
                      {score.name}
                    </span>
                    <p className="text-body-lg-bold min-[360px]:text-[28px] md:text-display-lg text-white">{score.total}</p>
                  </div>
                  {i !== teamScores.length - 1 && (
                    <div className="team-header-scores_slash self-center">
                      <div className="bg-white w-px h-12 opacity-40"></div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <div className="team-header_overlay1 block [clip-path:polygon(600px_0,_100%_0,_100%_100%,_0%_100%)] md:[clip-path:polygon(200px_0,_100%_0,_100%_100%,_0%_100%)]" style={{left: animate ? '100%' : '130%'}}></div>
          <div className="team-header_overlay2 block [clip-path:polygon(300px_0,_100%_0,_100%_100%,_0%_100%)] md:[clip-path:polygon(552px_0,_100%_0,_100%_100%,_0%_100%)]" style={{left: animate ? '100%' : '70%'}}></div>
        </div>
        <div className="absolute bg-white w-full h-2 bottom-0 opacity-20"></div>
      </div>
  );
}
